export interface ITableRowProps {
	destination: string;
	airportCode: string;
	airline: string;
	sortedOn: 'destination' | 'airline';
}

export function NonStopDestinationsTableRow({
	destination,
	airportCode,
	airline,
	sortedOn,
}: ITableRowProps) {
	return (
		<tr>
			{sortedOn === 'airline' ? (
				<>
					<td className="airline-column">{airline}</td>
					<td className="airport-column">{airportCode}</td>
					<td>{destination}</td>
					<td aria-hidden="true" />
				</>
			) : (
				<>
					<td>{destination}</td>
					<td className="airport-column">{airportCode}</td>
					<td className="airline-column">{airline}</td>
					<td aria-hidden="true" />
				</>
			)}
		</tr>
	);
}
